import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import { addSessionId } from 'src/util/helpers';

interface NavigateFunction {
    (to: To, options?: NavigateOptions): void;
    (delta: number): void;
}

export const useFmtpNavigate = (): NavigateFunction => {
    const navigate = useNavigate();

    const fmtpNavigate: NavigateFunction = (to: To | number, options?: NavigateOptions) => {
        if (typeof to === 'number') {
            navigate(to);
        } else {
            navigate(addSessionId(to), options);
        }
    };

    return fmtpNavigate;
};
